export default __webpack_public_path__ + "static/media/element_79.0212dee1.webp";